import { MaybeVNode } from "../../../lib/utils/vue/MaybeVNode";
const defaultPositionRenderer = {
  after(action) {
    const h = this.$createElement;
    return h("div", {
      "class": "ucd-dataTreeNode-actionIconButton",
      "key": action.key,
      "on": {
        "click": ev => {
          var _action$execute;
          ev.preventDefault();
          ev.stopPropagation();
          (_action$execute = action.execute) === null || _action$execute === void 0 || _action$execute.call(action, ev);
        }
      }
    }, [h("a-tooltip", {
      "attrs": {
        "title": action.title || '',
        "overlayClassName": "ucd-dataTreeNode-actionIconButton-tooltip"
      }
    }, [h("div", {
      "class": "ucd-dataTreeNode-actionIconButton-icon"
    }, [h(MaybeVNode, {
      "attrs": {
        "fallback": "fa-icon",
        "value": action.icon
      }
    })])])]);
  },
  'before-children'(action) {
    const h = this.$createElement;
    return h("div", {
      "class": "ucd-dataTreeActions-action",
      "key": action.key,
      "on": {
        "click": ev => {
          var _action$execute2;
          ev.preventDefault();
          ev.stopPropagation();
          (_action$execute2 = action.execute) === null || _action$execute2 === void 0 || _action$execute2.call(action, ev);
        }
      }
    }, [action.icon && h("div", {
      "class": "ucd-dataTreeActions-actionIcon"
    }, [h("i", {
      "class": action.icon,
      "attrs": {
        "aria-hidden": "true"
      }
    })]), ` ${action.title}`]);
  },
  'after-children'(action) {
    const h = this.$createElement;
    return h("div", {
      "class": "ucd-dataTreeActions-action",
      "key": action.key,
      "on": {
        "click": ev => {
          var _action$execute3;
          ev.preventDefault();
          ev.stopPropagation();
          (_action$execute3 = action.execute) === null || _action$execute3 === void 0 || _action$execute3.call(action, ev);
        }
      }
    }, [action.icon && h("div", {
      "class": "ucd-dataTreeActions-actionIcon"
    }, [h("i", {
      "class": action.icon,
      "attrs": {
        "aria-hidden": "true"
      }
    })]), ` ${action.title}`]);
  },
  'data-path-selector'() {
    return null;
  }
};
const DSActionsRenderer = {
  name: 'DSActionsRenderer',
  functional: true,
  props: {
    actions: {
      type: Array,
      required: true
    },
    position: {
      type: String,
      required: true
    }
  },
  render($createElement, context) {
    const {
      props
    } = context;
    return props.actions.map(action => {
      var _defaultPositionRende;
      const position = action.position || 'after';
      if (position !== props.position) return null;
      if (action.vnode) return action.vnode;
      return (_defaultPositionRende = defaultPositionRenderer[position]) === null || _defaultPositionRende === void 0 ? void 0 : _defaultPositionRende.call(context.parent, action);
    });
  }
};
export default DSActionsRenderer;
//# sourceMappingURL=DSActionsRenderer.js.map
